<template>
  <div>
      <div class="white--text blue darken-2" id="jumbo">
        <v-container>
            <v-row align="center">
                <v-col class="text-left" cols="12">
                <h1 class="display-1 font-weight-bold mb-4">O strani</h1>
                </v-col>
            </v-row>
        </v-container>
      </div>
      <div>
        <v-container>
          <v-row>
          <h2>
            Avtor: <div class="font-weight-regular">Geza Horvat</div>
          </h2>
          </v-row>
          <v-row>
          <h2>
            Kontakt: 
            <div class="font-weight-regular">
              <a href="mailto:geza_horvat@t-2.net" class="text-decoration-none">geza_horvat@t-2.net</a>
            </div>
          </h2>
          </v-row>
          <v-row>
          <h2>
            YouTube kanal:
            <div class="font-weight-regular">
              <a href="https://www.youtube.com/channel/UCaNAZAJLNhPypJIhgCHByiQ/" class="text-decoration-none">Klik</a>
            </div>
          </h2>
          </v-row>
        </v-container>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'About'
  }
</script>

<style scoped>

</style>